/**
 * 系統外殼的「管理權限」判定——唯一一份，畫面與測試共用。
 *
 * 為什麼要集中一支：舊的 `AdminAccessNotice` 只看「sessionStorage 裡有沒有 token」，
 * 於是把三件不同的事說成同一句「系統頁需要管理權限」：
 *   1. 真的沒有憑證（還沒做一次性設定）         → 該說「需要管理權限」＋設定入口
 *   2. 有憑證但後端回 401／403（過期／撤銷／錯） → 該說「憑證失效，請重新登入」
 *   3. 有憑證但 5xx／斷網                       → **不是權限問題**，交回頁面自己的錯誤態
 *
 * 硬規則：**只有 401／403 可以說「權限」**。分類本身不重寫，直接借用 `api/data-state.ts`
 * 的 `errorKindOf()`（狀態碼優先、再看字樣），外殼與各頁因此永遠同一套判斷。
 */
import { errorKindOf } from './data-state';
function messageOf(error) {
    if (error instanceof Error)
        return error.message;
    return typeof error === 'string' ? error : '';
}
/**
 * 一次 admin 請求的失敗 → 外殼該顯示的狀態。
 *
 * 同樣是 401：有憑證＝過期（叫使用者重新登入），沒有憑證＝還沒設定（給設定入口）；
 * 這個差別就是舊版最常誤導人的地方。
 */
export function resolveAdminAccess(input) {
    const message = messageOf(input.error);
    const kind = errorKindOf(input.error);
    const isAuth = kind === 'unauthorized' || (input.fromAuthChannel === true && kind === 'error');
    if (!isAuth)
        return { kind: 'unavailable', message };
    return input.hasToken ? { kind: 'expired', message } : { kind: 'missing', message };
}
/** 這個狀態要不要佔版面？（`unavailable` 一定不顯示，5xx／斷網交給頁面） */
export function shouldShowAdminAccess(state) {
    return state.kind === 'missing' || state.kind === 'expired';
}
/** 一進來（還沒打任何請求）該長什麼樣：只有「完全沒有憑證」才需要說權限。 */
export function initialAdminAccess(hasToken) {
    return hasToken ? { kind: 'none' } : { kind: 'missing' };
}
//# sourceMappingURL=admin-access.js.map